import React from 'react';
import { Link } from 'react-router-dom';
import History from '@/components/contents/history/HistoryWaiting';
import { getLocaleWordContent } from '@/utils/language.util';

export default function HistoryWaitPage() {
    return (
        <div id="wrap" className="main sub_page">
            <div className="history">
                <Link to="/home" className="tit">
                    <h2 className="inner">{getLocaleWordContent('상품판매현황')}</h2>
                </Link>
                <div className="inner">
                    <History />
                </div>
            </div>
        </div>
    );
}
